import React, { useEffect, useState } from "react";
import { CreditCard, Smartphone, Copy, Check } from "lucide-react";
import api from "../lib/api";

export default function Access() {
  const [data, setData] = useState({ description: "", pricing: [], bank_account: "", blik_phone: "", payment_info: "" });
  useEffect(() => {
    api.get("/access").then((r) => setData(r.data));
  }, []);

  return (
    <div data-testid="access-page" className="bg-[#2A2A2A] min-h-screen">
      <header className="bg-[#1F1F1F] border-b border-[#3a3a3a] py-20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="kicker mb-5">Cennik / Dostęp</div>
          <h1 className="font-display text-white text-5xl md:text-7xl uppercase leading-[0.9]">
            Dostęp do<br/><span className="text-[#FFCC00]">pracowni</span>
          </h1>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-16">
          <div>
            <div className="kicker mb-4">Opis</div>
            <p className="text-white/80 text-lg leading-relaxed">{data.description}</p>
          </div>
          <div>
            <div className="kicker mb-4">Cennik</div>
            <table className="pricing-table w-full border-collapse text-white" data-testid="pricing-table">
              <thead>
                <tr>
                  <th>Pakiet / Wariant</th>
                  <th className="text-right">Cena</th>
                </tr>
              </thead>
              <tbody>
                {(data.pricing || []).filter(p => p.label).map((p, i) => (
                  <tr key={i} data-testid={`price-row-${i}`}>
                    <td className="text-white/85">{p.label}</td>
                    <td className="price text-right">{p.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mt-4 text-xs text-white/50 font-mono-acc">
              * Ceny brutto. Płatność BLIK / karta / przelew.
            </p>
          </div>
        </div>
      </section>

      {/* Payment section */}
      <section className="bg-[#1F1F1F] border-t border-[#3a3a3a] py-16 md:py-20" data-testid="payment-section">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="kicker mb-4">Płatność</div>
          <h2 className="font-display text-white text-3xl md:text-5xl uppercase mb-10">
            Przelew lub <span className="text-[#FFCC00]">BLIK</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6">
            <CopyCard
              icon={CreditCard}
              label="Numer konta bankowego"
              value={data.bank_account}
              testid="bank-account"
            />
            <CopyCard
              icon={Smartphone}
              label="BLIK na telefon"
              value={data.blik_phone}
              testid="blik-phone"
            />
          </div>

          {data.payment_info && (
            <div className="mt-8 p-6 border-l-4 border-[#FFCC00] bg-[#2A2A2A] text-white/80 leading-relaxed max-w-3xl">
              {data.payment_info}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

function CopyCard({ icon: Icon, label, value, testid }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="bg-[#2A2A2A] border border-[#3a3a3a] p-6 md:p-8 group" data-testid={testid}>
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 bg-[#FFCC00] flex items-center justify-center flex-shrink-0">
          <Icon size={22} className="text-[#2A2A2A]"/>
        </div>
        <div>
          <div className="font-mono-acc text-[10px] uppercase text-white/50">{label}</div>
          <div className="font-display text-white text-xl md:text-2xl mt-1 break-all">{value || "—"}</div>
        </div>
      </div>
      <button
        onClick={copy}
        disabled={!value}
        className="font-mono-acc text-[11px] uppercase text-[#FFCC00] hover:underline inline-flex items-center gap-2 disabled:opacity-40"
      >
        {copied ? <><Check size={14}/> Skopiowano</> : <><Copy size={14}/> Kopiuj</>}
      </button>
    </div>
  );
}
